import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import destroy from "@utils/alpine-destroy";
import factory from "@utils/factory";

import masonry from "@utils/masonry";

import globaStore from "@stores/global";

import header from "@modules/header";
import headerFilter from "@modules/header-filter";
import collection from "@modules/collection";
import product from "@modules/product";
import recommendations from "@modules/recommendations";
import cartBubble from "@modules/cart-bubble";
import cart from "@modules/cart";
import addresses from "@modules/addresses";
import slider from "@modules/slider";
import collectionSlider from "@modules/collection-slider";
import blogSlider from "@modules/blog-slider";
import accordion from "@modules/accordion";
import instagram from "@modules/instagram";
import materials from "@modules/materials";
import dialog from "modules/cookiehub-dialog";

window.Alpine = Alpine;

Alpine.plugin(destroy);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.store("global", globaStore);

Alpine.data("header", header);
Alpine.data("headerFilter", headerFilter);
Alpine.data("collection", collection);
Alpine.data("product", product);
Alpine.data("recommendations", recommendations);
Alpine.data("cartBubble", cartBubble);
Alpine.data("cart", cart);
Alpine.data("addresses", addresses);
Alpine.data("slider", slider);
Alpine.data("collectionSlider", collectionSlider);
Alpine.data("blogSlider", blogSlider);
Alpine.data("accordion", accordion);
Alpine.data("instagram", instagram);
Alpine.data("materials", materials);

Alpine.start();

factory(masonry, ".js-masonry");
dialog.init();
